import { ResultRecord, ServiceResponse } from "@rsm-hcd/javascript-core";
import PromptSuggestionsRecord from "models/view-models/conversations/prompt-suggestions/prompts-suggestions-record";
import type { QueryObserverOptions } from "react-query/types/core/types";
import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";

const endpoint = "prompt-suggestions";
const key = "prompt-suggestions";

type PromptSuggestionsQueryOptions = QueryObserverOptions<
    ServiceResponse<PromptSuggestionsRecord>,
    ResultRecord<PromptSuggestionsRecord>
>;

const PromptSuggestionsService = {
    key,

    // this is so that it's more convenient
    // get(options) instead of get(undefined, undefined, options)
    useGetPromptsQuery: () => {
        const { get } = QueryHookFactory.useGetQuery<
            PromptSuggestionsRecord,
            undefined,
            undefined
        >(key, PromptSuggestionsRecord, endpoint)();

        return {
            get: (options?: PromptSuggestionsQueryOptions) =>
                get(undefined, undefined, options),
        };
    },
};

export default PromptSuggestionsService;
